module.exports = __webpack_public_path__ + "static/media/default.3b70e2c3.jpg";